import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment GalleryItemFragment on GalleryItem {
    id
    type
    data {
      galleryId
      title
      images {
        ...ImageDataFragment
      }
    }
  }
  ${ImageDataFragment}
`;
